import { createProviderToken } from '@core/common-legacy';

export function isHostOneDomain(oneDomainUrl: string) {
  return oneDomainUrl.includes(document.location.hostname);
}

export const { inject: injectIsOneDomain, provide: provideIsOneDomain } =
  createProviderToken<boolean>('isOneDomain')();
